import React from "react";
import { motion } from "framer-motion";
import { FaCartPlus, FaHeadset, FaUserTie, FaUtensils } from "react-icons/fa6";
import { PiPlugsConnectedFill } from "react-icons/pi";
import { FaTools, FaListAlt, FaChartLine } from "react-icons/fa";
import { TbSourceCode } from "react-icons/tb";
import { CiImport } from "react-icons/ci";
import { Link } from "react-router-dom";
import { AiOutlineAudit } from "react-icons/ai";
import NavDropdown from "react-bootstrap/NavDropdown";

const GridCards = () => {
  const servicesData = [
    {
      icon: <CiImport size={50} className="text-sky-500 mb-4" />,
      title: "Import",
      link: "/import",
      type: "import",
      description:
        "Import product and location data via CSV, XLSX, PDF and other formats.",
    },
    {
      icon: <FaCartPlus size={50} className="text-sky-500 mb-4" />,
      title: "Manage",
      link: "/products",
      type: "manage",
      description:
        "View and Edit your products, including meta-data, images and videos.",
    },
    {
      icon: <PiPlugsConnectedFill size={50} className="text-sky-500 mb-4" />,
      title: "SmartPipes",
      link: "/marketplace",
      type: "smartpipes",
      description:
        "View and configure SmartPipes, including connectors, destinations and validations.",
    },
    {
      icon: <FaHeadset size={50} className="text-sky-500 mb-4" />,
      title: "Support",
      link: "/support",
      type: "normal",
      description:
        "Need support or have questions? nutrād provides 24/7 online support.",
    },
    {
      icon: <FaTools size={50} className="text-sky-500 mb-4" />,
      title: "Tools",
      link: "/tools",
      type: "tools",
      description:
        "Need to search for a specific GTIN or GLN? Use these tools to find what you need.",
    },
    // {
    //   icon: <TbSourceCode size={50} className="text-sky-500 mb-4" />,
    //   title: "Developers",
    //   link: "/developer",
    //   type: "developers",
    //   description:
    //     "Need to search for a specific GTIN or GLN? Use these tools to find what you need.",
    // },
    {
      icon: <AiOutlineAudit size={50} className="text-sky-500 mb-4" />,
      title: "Reports",
      link: "/audits",
      type: "reports",
      description: "View all publishing jobs and view the status of each job.",
    },
    {
      icon: <FaListAlt size={50} className="text-sky-500 mb-4" />,
      title: "Field Lists",
      link: "/field-lists",
      type: "fieldlists",
      description:
        "Manage field lists for your products and data imports.",
    },
    {
      icon: <FaChartLine size={50} className="text-sky-500 mb-4" />,
      title: "Analytics",
      link: "/analytics/publishing",
      type: "analytics",
      description:
        "View product and publishing analytics — success rates, mapping coverage, processing trends and more.",
    },
  ];

  return (
    <div className="py-12 bg-sky-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {servicesData.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, translateY: 20 }}
              animate={{ opacity: 1, translateY: 0 }}
              transition={{
                duration: 0.3,
                delay: index * 0.2,
                ease: "easeOut",
              }}
              whileHover={{
                scale: 1.05,
                boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
              }}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-50"
            >
              <div className="p-6 text-center">
                <div className="flex justify-center mb-4">{service.icon}</div>
                <h5 className="text-xl font-semibold text-gray-800 mb-3">
                  {service.title}
                </h5>
                <p className="text-gray-600 mb-4">{service.description}</p>

                {service.type === "normal" ? (
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="relative flex justify-center"
                  >
                    <NavDropdown
                      title="Help"
                      id="import-dropdown"
                      className="bg-sky-500 text-white rounded-md hover:bg-sky-600 transition-colors px-4 py-2 "
                    >
                      <NavDropdown.Item
                        href="/support"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Support
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        href="/tutorials"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Tutorials
                      </NavDropdown.Item>
                    </NavDropdown>
                  </motion.div>
                ) : service.type === "import" ? (
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="relative flex justify-center"
                  >
                    <NavDropdown
                      title="Import"
                      id="import-dropdown"
                      className="bg-sky-500 text-white rounded-md hover:bg-sky-600 transition-colors px-4 py-2 "
                    >
                      <NavDropdown.Item
                        href="/import"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Import Product Data Files
                      </NavDropdown.Item>

                      {/* <NavDropdown.Item
                        href="/import_gln"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Single GLN Data File
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        href="/import_loc"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Combine Multiple GLN Data Files
                      </NavDropdown.Item> */}
                    </NavDropdown>
                  </motion.div>
                ) : service.type === "manage" ? (
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="relative flex justify-center"
                  >
                    <NavDropdown
                      title="Manage"
                      id="manage-dropdown"
                      className="bg-sky-500 text-white rounded-md hover:bg-sky-600 transition-colors px-4 py-2 "
                    >
                      <NavDropdown.Item
                        href="/products"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Manage
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="/s3"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Exported Files
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="/ai-field-logic"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        AI Field Logic
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="/schema/upload"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Schema Upload
                      </NavDropdown.Item>
                    </NavDropdown>
                  </motion.div>
                ) : service.type === "reports" ? (
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="relative flex justify-center"
                  >
                    <NavDropdown
                      title="Reports"
                      id="manage-dropdown"
                      className="bg-sky-500 text-white rounded-md hover:bg-sky-600 transition-colors px-4 py-2 "
                    >
                      <NavDropdown.Item
                        href="/publishing-reports"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Publishing Reports
                      </NavDropdown.Item>
                    </NavDropdown>
                  </motion.div>
                ) : service.type === "tools" ? (
                  <>
                    <motion.div
                      whileHover={{ scale: 1.05 }}
                      className="relative flex justify-center"
                    >
                      <NavDropdown
                        title="Tools"
                        id="manage-dropdown"
                        className="bg-sky-500 text-white rounded-md hover:bg-sky-600 transition-colors px-4 py-2 "
                      >
                        <NavDropdown.Item
                          href="/gtin_search"
                          className="text-gray-700 hover:bg-sky-50"
                        >
                          GTIN Search
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href="/gln_search"
                          className="text-gray-700 hover:bg-sky-50"
                        >
                          GLN Search
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href="/s3"
                          className="text-gray-700 hover:bg-sky-50"
                        >
                          Recall Search
                        </NavDropdown.Item>
                      </NavDropdown>
                    </motion.div>
                  </>
                ) : service.type === "analytics" ? (
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="relative flex justify-center"
                  >
                    <NavDropdown
                      title="Analytics"
                      id="analytics-dropdown"
                      className="bg-sky-500 text-white rounded-md hover:bg-sky-600 transition-colors px-4 py-2"
                    >
                      <NavDropdown.Item
                        href="/analytics/dashboard"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Product Analytics
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="/analytics/publishing"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Publishing Analytics
                      </NavDropdown.Item>
                    </NavDropdown>
                  </motion.div>
                ) : service.type === "developers" ? (
                  <>
                    <motion.div
                      whileHover={{ scale: 1.05 }}
                      className="relative flex justify-center"
                    >
                      <NavDropdown
                        title="Developers"
                        id="manage-dropdown"
                        className="bg-sky-500 text-white rounded-md hover:bg-sky-600 transition-colors px-4 py-2 "
                      >
                        <NavDropdown.Item
                          href="http://localhost:5050/api/docs"
                          className="text-gray-700 hover:bg-sky-50"
                        >
                          Documentation
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href="https://geometric-bay-452700-j9-nutrad.apigee.io/"
                          className="text-gray-700 hover:bg-sky-50"
                        >
                          Developer Portal
                        </NavDropdown.Item>
                      </NavDropdown>
                    </motion.div>
                  </>
                ) : (
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="relative flex justify-center"
                  >
                    <NavDropdown
                      title="SmartPipes"
                      id="smartpipes-dropdown"
                      className="bg-sky-500 text-white rounded-md hover:bg-sky-600 transition-colors px-4 py-2 "
                    >
                      <NavDropdown.Item
                        href="/connections"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Connections
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="/destinations"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Destinations
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="/validations"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        Validations
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="/gdsn"
                        className="text-gray-700 hover:bg-sky-50"
                      >
                        GDSN Datapools
                      </NavDropdown.Item>
                    </NavDropdown>
                  </motion.div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GridCards;
